Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var isFixedSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    box = _STYLES$useStyles.box,
    colors = _STYLES$useStyles.colors,
    COLORS = _STYLES$useStyles.COLORS,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    fontBold = _STYLES$useStyles.fontBold,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    fontRegular = _STYLES$useStyles.fontRegular;
  var _isNotFixedSize = !isFixedSize && bp.is([bp.tablet, bp.desktop_normal, bp.desktop_m]);
  var _factor = 1;
  if (_isNotFixedSize) {
    _factor = 1.35;
  }
  var container = {
    maxWidth: '100%'
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    container = Object.assign({}, container, box);
  }
  var background = {
    width: 368 * _factor,
    height: 265 * _factor,
    alignSelf: 'center'
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    background.display = 'none';
  }
  var backgroundImage = {
    width: '100%',
    height: '100%'
  };
  var cloudPurple = {
    position: 'absolute',
    top: 2 * _factor,
    left: 0 * _factor,
    width: 368 * _factor,
    height: 242 * _factor
  };
  var leafSmall1 = {
    position: 'absolute',
    top: 18 * _factor,
    left: 269 * _factor,
    width: 55 * _factor,
    height: 48 * _factor
  };
  var leafBig1 = {
    position: 'absolute',
    top: 50 * _factor,
    left: 275 * _factor,
    width: 86 * _factor,
    height: 30 * _factor
  };
  var leafSmall2 = {
    position: 'absolute',
    top: 211 * _factor,
    left: 46 * _factor,
    width: 62 * _factor,
    height: 53 * _factor
  };
  var leafBig2 = {
    position: 'absolute',
    top: 197 * _factor,
    left: 9 * _factor,
    width: 94 * _factor,
    height: 36 * _factor
  };
  var cloudWhite = {
    position: 'absolute',
    top: 14 * _factor,
    left: 23 * _factor,
    width: 322 * _factor,
    height: 221 * _factor
  };
  var content = Object.assign({}, _reactNative.StyleSheet.absoluteFillObject, {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  });
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    content.position = 'relative';
  }
  var title = Object.assign({}, fontBold, {
    fontSize: _styles.STYLES.fontSize.m,
    lineHeight: _styles.STYLES.lineHeight.m,
    color: colors.alternative,
    textAlign: 'center',
    marginTop: spacing.xs
  });
  if (_isNotFixedSize) {
    title.fontSize = _styles.STYLES.fontSize.l;
    title.lineHeight = _styles.STYLES.lineHeight.l;
  }
  var value = Object.assign({
    fontSize: _styles.STYLES.fontSize.xxl,
    color: colors.brand
  }, _reactNative.Platform.select({
    web: {
      lineHeight: "calc(".concat(_styles.STYLES.fontSize.xxl, " * 1.2)")
    },
    "default": {
      lineHeight: _styles.STYLES.fontSize.xxl * 1.2
    }
  }));
  var unit = {
    fontSize: _styles.STYLES.fontSize.normal,
    color: colors.brand
  };
  var text = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: colors.brand,
    textAlign: 'center'
  });
  if (_isNotFixedSize) {
    text.fontSize = _styles.STYLES.fontSize.normal;
    text.lineHeight = _styles.STYLES.lineHeight.normal;
  }
  var button = {
    marginTop: spacing.xs
  };
  var comparisonContainer = {
    paddingTop: spacing.xs,
    paddingBottom: spacing.xs,
    paddingLeft: spacing.s,
    paddingRight: spacing.s,
    borderRadius: (0, _styles.getREM)(1.15625),
    marginTop: spacing.xs,
    maxWidth: (0, _styles.getREM)(13 * _factor)
  };
  var comparisonContainer_less = {
    backgroundColor: (0, _styles.getOpaqueColor)(COLORS.atlantis, 0.2)
  };
  var comparisonContainer_equal = {
    backgroundColor: (0, _styles.getOpaqueColor)(COLORS.cherry, 0.2)
  };
  var comparisonContainer_more = {
    backgroundColor: (0, _styles.getOpaqueColor)(COLORS.cherry, 0.2)
  };
  var comparisonText = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: _styles.STYLES.lineHeight.xs,
    textAlign: 'center',
    color: COLORS.aubergine
  });
  var styles = _reactNative.StyleSheet.create({
    container: container,
    background: background,
    backgroundImage: backgroundImage,
    cloudPurple: cloudPurple,
    leafSmall1: leafSmall1,
    leafBig1: leafBig1,
    leafSmall2: leafSmall2,
    leafBig2: leafBig2,
    cloudWhite: cloudWhite,
    content: content,
    title: title,
    value: value,
    unit: unit,
    text: text,
    button: button,
    comparisonContainer: comparisonContainer,
    comparisonContainer_less: comparisonContainer_less,
    comparisonContainer_equal: comparisonContainer_equal,
    comparisonContainer_more: comparisonContainer_more,
    comparisonText: comparisonText
  });
  return {
    styles: styles,
    backgroundHidden: bp.mobile_xs || bp.mobile_s || bp.mobile_normal
  };
};